import React from 'react';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { TomosSection } from './components/TomosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { CostSection } from './components/CostSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ink-950 font-sans" data-id="element-0" data-mp="28u5zysgmvffh">
      <Hero data-id="element-1" data-mp="28suv0pbgc1ms" />
      <main data-id="element-2" data-mp="28sbcb6dz997p">
        <TomosSection data-id="element-3" data-mp="28s2z1ddy01vz" />
        <SalesLetter data-id="element-4" data-mp="23vune9yyeqtk" />
        <BenefitsSection data-id="element-5" data-mp="23u9vks40xlze" />
        <BonosSection data-id="element-6" data-mp="23v2sz2h3ez4v" />
        <PricingSection data-id="element-7" data-mp="23ti5fwt74ggi" />
        <CostSection data-id="element-8" data-mp="3ikh98cxzsz0k" />
        <TestimonialsSection data-id="element-9" data-mp="3ij652c0mxp8x" />
        <GuaranteeSection data-id="element-10" data-mp="3ihv2gfixenje" />
        <FaqSection data-id="element-11" data-mp="3mlawr57iwbsx" />
        <FinalCta data-id="element-12" data-mp="3mkrbpfmkt7ao" />
      </main>
      <Footer data-id="element-13" data-mp="3mjztd6hzp62c" />
    </div>;
}